export function getOpeTotalCurrency(items, nativeCurrency = "INR") {
  const currencies = [...new Set(items.map((item) => item.currency))];
  return currencies.length === 1 ? currencies[0] : nativeCurrency;
}

export function calculateOpeBreakdown(items, targetCurrency, settings) {
  const rate = (code) => {
    if (code === (settings?.nativeCurrencyCode || "INR")) return 1;
    const value = Number(settings?.conversionRates?.find((entry) => entry.currencyCode === code)?.rate);
    if (!Number.isFinite(value) || value <= 0) throw new Error(`Configure an exchange rate for ${code}.`);
    return value;
  };
  const converted = items.map((item) => {
    if (typeof item.name !== "string" || !item.name.trim() || item.name.trim().length > 200) throw new Error("Enter a name of up to 200 characters for every attachment.");
    if (!["INR", "USD", "SGD", "JPY", "EUR", "GBP"].includes(item.currency)) throw new Error("Select a currency for every attachment.");
    if (!/^\d+(\.\d{1,2})?$/.test(String(item.amount))) throw new Error("Enter an amount with up to two decimal places for every attachment.");
    const amount = Number(item.amount);
    if (!Number.isFinite(amount) || amount < 0) throw new Error("Enter a valid attachment amount.");
    const conversionRate = item.currency === targetCurrency ? 1 : rate(item.currency) / rate(targetCurrency);
    const convertedAmount = Math.round((amount * conversionRate + Number.EPSILON) * 100) / 100;
    if (!Number.isSafeInteger(Math.round(convertedAmount * 100))) throw new Error("Attachment amount is too large.");
    return { ...item, name: item.name.trim(), amount: amount.toFixed(2), conversionRate, convertedAmount: convertedAmount.toFixed(2) };
  });
  const totalCents = converted.reduce((sum, item) => sum + Math.round(Number(item.convertedAmount) * 100), 0);
  if (!Number.isSafeInteger(totalCents)) throw new Error("OPE total is too large.");
  return { items: converted, total: (totalCents / 100).toFixed(2) };
}
